@if (href || isShow) {
  @if (!isExternal) {
    <a
      [routerLink]="dataRelativePath ? []: [href]"
      (click)="dataRelativePath ? navigateRelatively():null"
      routerLinkActive="active-link"
      class="{{dataClasses}}"
      id="{{dataId}}"
      [fragment]="fragment"
      [target]="target"
      [queryParams]="query_params"
      attr.aria-label="{{dataAriaLabel|translate}}" closeComponent>
      <span class="link-text" translate closeComponent>{{dataText}}</span>
      @if (dataMoreinfo?.length) {
        <span class="sr-only">{{dataMoreinfo}}</span>
      }
      <ng-container [ngTemplateOutlet]="content"></ng-container>
      <!--<ng-content select=".more-info"></ng-content>-->
    </a>
  } @else {
    <a [href]="href"  class="{{dataClasses}}" [target]="target" id="{{dataId}}">
      <ng-container [ngTemplateOutlet]="content"></ng-container>
    </a>
  }
}

<ng-template #content>
  <ng-content></ng-content>
</ng-template>

@if (!href && (sectionAnchor || fragment)) {
  <a [routerLink]="[]" [fragment]="fragment||sectionAnchor" attr.aria-label="{{dataAriaLabel|translate}}" (click)="scroll()" class="{{dataClasses}}" id="{{dataId}}" closeComponent>
    <span class="link-text" translate closeComponent>{{dataText}}</span>
    @if (dataMoreinfo?.length) {
      <span class="sr-only">{{dataMoreinfo}}</span>
    }
    <ng-content select=".anchor-content"></ng-content>
  </a>
}
